export interface Review {
  id: string;
  name: string;
  role: string;
  content: string;
  rating: number;
  avatar: string;
}

export const reviews: Review[] = [
  {
    id: 'r1',
    name: '张伟',
    role: '美食创作者 · 粉丝 128万',
    content: '黄瓜视频是我用过最友好的创作平台，剪辑工具简单易用，社区氛围也特别好。在这里分享美食视频一年多了，不仅收获了百万粉丝，还认识了很多志同道合的朋友。推荐所有想做短视频的朋友都来试试！',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Chinese%20man%20in%20his%2030s%2C%20friendly%20smile%2C%20clean%20white%20background%2C%20business%20casual%20style%2C%20warm%20lighting%2C%20natural%20expression%2C%20high%20quality%20portrait&width=120&height=120&seq=review-avatar-1&orientation=squarish',
  },
  {
    id: 'r2',
    name: '李雪',
    role: '旅行博主 · 粉丝 86万',
    content: '作为一个旅行博主，我最喜欢黄瓜视频的离线剪辑功能。在飞机上、在深山里都能随时剪辑视频，这让我的创作效率提升了好几倍。平台的推荐算法也很准，内容总能推送给感兴趣的用户。',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Chinese%20woman%20in%20her%2020s%2C%20warm%20smile%2C%20clean%20white%20background%2C%20casual%20style%2C%20bright%20lighting%2C%20natural%20expression%2C%20high%20quality%20portrait&width=120&height=120&seq=review-avatar-2&orientation=squarish',
  },
  {
    id: 'r3',
    name: '王浩',
    role: '游戏解说 · 粉丝 256万',
    content: '从其他平台转到黄瓜视频后，我的内容播放量提升了3倍！这里的游戏社区非常活跃，观众互动率远超其他平台。而且平台的创作者激励计划真的很香，让我能够全职做自己喜欢的事情。',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Chinese%20man%2C%20confident%20smile%2C%20clean%20white%20background%2C%20modern%20casual%20style%2C%20studio%20lighting%2C%20energetic%20expression%2C%20high%20quality%20portrait&width=120&height=120&seq=review-avatar-3&orientation=squarish',
  },
  {
    id: 'r4',
    name: '陈婷',
    role: '音乐人 · 粉丝 65万',
    content: '黄瓜视频的音乐版权库太全了！作为原创音乐人，我既能找到合适的BGM用于创作，也能通过平台的音乐人扶持计划推广自己的作品。真心觉得这是一个尊重创作者的好平台。',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Chinese%20woman%20with%20artistic%20style%2C%20gentle%20smile%2C%20clean%20white%20background%2C%20creative%20look%2C%20soft%20lighting%2C%20elegant%20expression%2C%20high%20quality%20portrait&width=120&height=120&seq=review-avatar-4&orientation=squarish',
  },
  {
    id: 'r5',
    name: '刘洋',
    role: '科普创作者 · 粉丝 42万',
    content: '做知识科普内容最怕的就是没人看，但黄瓜视频的用户真的很喜欢学习型内容。我的「3分钟冷知识」系列在这里获得了超过千万的播放量，评论区的讨论质量也非常高，让我有了持续创作的动力。',
    rating: 4,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Chinese%20man%20with%20glasses%2C%20thoughtful%20smile%2C%20clean%20white%20background%2C%20smart%20casual%20style%2C%20warm%20lighting%2C%20intellectual%20expression%2C%20high%20quality%20portrait&width=120&height=120&seq=review-avatar-5&orientation=squarish',
  },
  {
    id: 'r6',
    name: '赵琳',
    role: '健身教练 · 粉丝 98万',
    content: '黄瓜视频的互动功能设计得特别好，我可以在视频下面直接回答粉丝的健身问题，还能发起挑战活动让大家一起参与。这种社区氛围让我的粉丝粘性特别高，真的很感谢这个平台。',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20an%20athletic%20Chinese%20woman%2C%20bright%20smile%2C%20clean%20white%20background%2C%20sporty%20style%2C%20energetic%20lighting%2C%20confident%20expression%2C%20high%20quality%20portrait&width=120&height=120&seq=review-avatar-6&orientation=squarish',
  },
];